// Wordt door esbuild gebundeld naar www/capacitor-bridge.js (zie scripts/build.js).
//
// Capacitor 6 verwacht dat NPM-plugins via `registerPlugin` worden geladen. In
// index.html (non-module script, geen bundler) lukt dat niet inline. Daarom
// doen we het hier in een afzonderlijk bundle en exposeren we het resultaat op
// window.ZestioNative.
//
// We importeren NIET `@capacitor-firebase/authentication` als hele package,
// omdat die zijn web-implementatie lazy-laadt via `import('./web')` en die
// importeert `firebase/auth`. Op iOS-native gebruiken we uitsluitend de
// Capacitor JS-bridge naar de native plugin, dus de web-implementatie hoeft
// nooit geladen te worden. `registerPlugin('FirebaseAuthentication')` levert
// exact de proxy die we nodig hebben — identiek aan wat de NPM-package
// intern doet, maar zonder firebase-peer-dep.
import { Capacitor, registerPlugin } from '@capacitor/core';

const FirebaseAuthentication = registerPlugin('FirebaseAuthentication');

const bridge = {
    Capacitor,
    registerPlugin,
    FirebaseAuthentication,
    isNativePlatform: () => Capacitor.isNativePlatform(),
    getPlatform: () => Capacitor.getPlatform(),
};

if (typeof window !== 'undefined') {
    window.ZestioNative = bridge;
}

export default bridge;
